import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const KamsContainer = () => import('@/containers/KamsContainer')
const TheAdminContainer = () => import('@/containers/TheAdminContainer')
const TheAdminGraphsContainer = () => import('@/containers/TheAdminGraphsContainer')

const Login = () => import('@/pages/application/login/Login')
const LoginLink = () => import('@/pages/application/login/LoginLink')
const AdminLoginLink = () => import('@/pages/application/login/AdminLoginLink')

const Dashboard = () => import('@/pages/administrator/Dashboard')
const Employers = () => import('@/pages/administrator/collaborators/Employers')
const Employees = () => import('@/pages/administrator/collaborators/Employees')

// Views
const Home = () => import('@/pages/application/Home')
const AdminHome = () => import('@/pages/administrator/AdminHome')
const AdminVisits = () => import('@/pages/administrator/AdminVisits')
const AdminImporter = () => import('@/pages/administrator/AdminImporter')

const AdminContracts = () => import('@/pages/administrator/AdminContracts')
const AdminContract = () => import('@/pages/administrator/AdminContract')

const AdminCollaborators = () => import('@/pages/administrator/AdminCollaborators')
const AdminCollaborator = () => import('@/pages/administrator/AdminCollaborator')

const Freelancers = () => import('@/pages/administrator/Freelancers')
const FreelanceImporter = () => import('@/pages/administrator/FreelanceImporter')
const FreelanceVisitTabulator = () => import('@/pages/administrator/FreelanceVisitTabulator')
const FreelanceVisits = () => import('@/pages/administrator/FreelanceVisits')
const FreelanceVisitsCompleted = () => import('@/pages/administrator/FreelanceVisitsCompleted')
const FreelanceVisitsPaid = () => import('@/pages/administrator/FreelanceVisitsPaid')

//Kams
const KamHome = () => import('@/pages/kams/KamHome')
const KamCustomer = () => import('@/pages/kams/Customer')
const KamRuta = () => import('@/pages/kams/Ruta')
const KamRutaGenerico = () => import('@/pages/kams/GenericRuta')
const KamUniverso = () => import('@/pages/kams/Universo')
const KamVisit = () => import('@/pages/kams/Visit')

//Admins graphics
const GraphsHome = () => import('@/pages/administrator/GraphsHome')
const GraphsHome2 = () => import('@/pages/administrator/GraphsHome2')
const GraphsKamsSupports = () => import('@/pages/administrator/GraphsKamsSupports')
const GraphsKamsBoss = () => import('@/pages/administrator/GraphsKamsBoss')
const GenericsBranches = () => import('@/pages/administrator/GenericsBranches')
const UniverseCustomers = () => import('@/pages/administrator/UniverseCustomers')

//Customer graphics
const CustomerGraphsHome = () => import('@/pages/administrator/CustomerGraphsHome')
const CustomerGraphsHome2 = () => import('@/pages/administrator/CustomerGraphsHome2')

const RHHome = () => import('@/pages/administrator/rrhh/Home')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'home',
          name: 'Inicio',
          component: Home
        },
        {
          path: '/home/:type',
          name: 'Inicio_type',
          component: Home
        },
        {
          path: '/home/:type/:date',
          name: 'Inicio_type_date',
          component: Home
        }
      ]
    },
    {
      path: '/',
      name: 'Visitas Freelance',
      component: TheAdminContainer,
      children: [    
        {
          path: 'freelancers',
          name: 'Promotores',
          component: Freelancers
        },
        {
          path: '/:code/login-link',
          name: 'LoginLink',
          meta: {
            is_public: true,
          },
          component: LoginLink
        },
        {
          path: '/:code/admin-login-link',
          name: 'AdminLoginLink',
          meta: {
            is_public: true,
          },
          component: AdminLoginLink
        },
        {
          path: 'freelance-visits/importer',
          name: 'Importador de Visitas',
          component: FreelanceImporter
        },
        {
          path: 'freelance-visits/tabulator',
          name: 'Tabulador de Visitas',
          component: FreelanceVisitTabulator
        },
        {
          path: 'freelance-visits/:tab',
          name: 'Visitas Freelance',
          component: FreelanceVisits
        },
        {
          path: 'freelance-visitsa/2:tab',
          name: 'Visitas por Pagar',
          component: FreelanceVisits
        },
        {
          path: 'freelance-visitsa/paid2',
          name: 'Visitas Pagadas',
          component: FreelanceVisitsPaid
        },
      ] 
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        is_public: true,
      },
      component: Login
    }
  ]
})